export const SET = 'SET';
export const CLEAR = 'CLEAR';